export default "__VITE_ASSET__9b41eaa9__"